import {App, IonicApp, Platform} from 'ionic-angular';
// import {StatusBar} from 'ionic-native';

import {HomePage} from './pages/home/home';
import {StudyGuideListPage} from './pages/study-guide-list/study-guide-list';
import {BulletinsPage} from "./pages/bulletins/bulletins";
import {CurrentPage} from "./pages/current/current";

@App({
  templateUrl: 'build/app.html',
  config: {} // http://ionicframework.com/docs/v2/api/config/Config/
})
export class MyApp {
  rootPage: any = CurrentPage;
  pages: Array<{title: string, component: any}>;

  constructor(platform: Platform, private app: IonicApp) {

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      // StatusBar.styleDefault();
    });

    this.pages = [
      { title: 'OC Grace First', component: CurrentPage },
      { title: 'Study Guides', component: StudyGuideListPage },
      { title: 'Bulletins', component: BulletinsPage }
    ];
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    let nav = this.app.getComponent('nav');
    nav.setRoot(page.component);
  }
}
